import { React, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Icon, { IconTypes } from "../../../../common/Icon";
import { IconButton, Slide, useMediaQuery } from "@mui/material";
import { ReactComponent as QuoteImage } from "../../../../../images/QuotationMarks.svg";

function CourseLandingPageReviews({ reviews = [] }) {
  const [index, setIndex] = useState(0);
  const [flowDirection, setFlowDirection] = useState("left");
  const [slideIn, setSlideIn] = useState(true);
  const isMobile = useMediaQuery("(max-width: 420px)");
  const currentReview = reviews[index];

  useEffect(() => {
    if (!isMobile) return;

    const timer = setTimeout(() => {
      handleNext();
    }, 15000);

    return () => clearTimeout(timer);
  }, [index, isMobile])

  const handlePrevious = () => {
    setFlowDirection("right");
    setSlideIn(false);
  }

  const handleNext = () => {
    setFlowDirection("left");
    setSlideIn(false);
  }

  const handleIndexUpdate = () => {
    if (slideIn === false) {
      if (flowDirection === "right") {
        setIndex((i) => (i === 0 ? reviews.length - 1 : i - 1));
      } else {
        setIndex((i) => (i === reviews.length - 1 ? 0 : i + 1));
      }
      setSlideIn(true);
    }
  }

  return (
    <div className="CourseLandingPage-reviews container">
      <div className="container-content">
        <h2>What <em><span className="lowercase">do students</span> </em>Say?</h2>
          <div className="reviews-carousel">
            <div className="back-button">
              <IconButton onClick={handlePrevious}>
                <Icon type={IconTypes.ArrowBack} />
              </IconButton>
            </div>
            <div className="container-review">
              <Slide 
                in={slideIn}
                direction={slideIn ? flowDirection : (flowDirection === "left" ? "right" : "left")}
                onExited={handleIndexUpdate}
                mountOnEnter
                unmountOnExit
              >
                <div className="review-card">
                  <h3>{currentReview.reviewTitle}</h3>
                  <div className="container-review">
                    <div className="review-icon">
                      <QuoteImage className="quote-left"/>
                    </div>
                    <div className="review">
                      <div className="review-content" dangerouslySetInnerHTML={{__html: currentReview.reviewContent}} />
                      <p className="review-author">{currentReview.reviewAuthor}</p>
                    </div>
                  </div>
                </div>
              </Slide>
            </div>
            <div className="forward-button">
              <IconButton onClick={handleNext}>
                <Icon type={IconTypes.ArrowForward} />
              </IconButton>
            </div>
          </div>
      </div>
    </div>
  )
}

CourseLandingPageReviews.propTypes = {
  reviews: PropTypes.array
};

export default CourseLandingPageReviews;